const state = {
  // 共享参数定义
  shareDefinitions: []
}
const getters = {
  shareDefinitions: (state) => state.shareDefinitions,
}
const mutations = {
  setShareDefinitions(state, data) {
    state.shareDefinitions = data
  },
}
const actions = {
  // 获取共享参数定义
  async loadDefinitions({ commit }, query) {
    try {
      const res = await this.$api.products.getShareParamDefinitions(query)
      commit('setShareDefinitions', res || [])
    } catch (error) {
      commit('setShareDefinitions', [])
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}
